import {DayOfWeekLayoutVo} from '../../common/shared/api/karina/vo/dayOfWeek/DayOfWeekLayoutVo.interface';
import {FilterOptionVo} from '../../common/shared/api/karina/vo/FilterOptionVo.interface';
import {DayOfWeekLayout} from '../generated/types';

export const createDayOfWeekLayout = (
  data: DayOfWeekLayoutVo
): DayOfWeekLayout => {
  return {
    selectedDay: withTranslateProperty(data.selected_day_opt),
    selectedSort: withTranslateProperty(data.selected_sort_opt),
    selectedReference: withTranslateProperty(data.selected_ref_opt),
    dayList: data.day_opt_list.map(withTranslateProperty),
    sortList: data.sort_opt_list.map(withTranslateProperty),
    referenceList: data.ref_opt_list.map(withTranslateProperty),
  };
};

const withTranslateProperty = ({
  translate_property,
  ...rest
}: FilterOptionVo) => {
  return {
    ...rest,
    translateProperty: translate_property,
  };
};
